module.exports = __webpack_public_path__ + "img/collaborate_14.d55a329c.jpg";